import React, { PropsWithChildren } from 'react';
import { Button, ButtonProps } from 'reactstrap';
import { PermissionComponentProps, PermissionComponent } from '../../Common/PermissionComponent';


export type PermissionButtonProps = PropsWithChildren<ButtonProps & PermissionComponentProps>;

export const PermissionButton: React.FC<PermissionButtonProps> = (props: Readonly<PermissionButtonProps>): JSX.Element => {

  const {
    permission,
    children,
    ...buttonProps
  } = props;

  return (
    <PermissionComponent permission={permission}>
      <Button {...buttonProps}>
        {children}
      </Button>
    </PermissionComponent>

  );

};
